import { contracts } from '../../data/contracts'

export default {
	name: 'NFTBOX',
	shortName: 'NFTBX',
	contractAddress: contracts[process.env.REACT_APP_NETWORK].nftBox,
	url: 'http://lorem.com',
	logo: 'tokens/OFood.png'
}
